import type {DataRouterEditBlobPagePayload} from '@github-ui/code-view-types'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'

import {codeViewAppBuilder} from '../config/app-builder'

export function buildCodeViewNewRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('codeViewNewRoute', {
    path: '/:owner/:repo/new/:branch/*',
    queries: [
      mainQuery<DataRouterEditBlobPagePayload>({
        queryDeps: ({pathname, searchParams}) => ({pathname, searchParams: Object.fromEntries(searchParams)}),
        encodeFetchPath: true,
      }),
    ],
    uiServiceOptions: {
      tsrConfig: {
        validateSearch: (
          search: Record<string, unknown>,
        ): {filename?: string; value?: string; message?: string; description?: string} =>
          search as {filename?: string; value?: string; message?: string; description?: string},
      },
    },
  })
}

export const codeViewNewRoute = buildCodeViewNewRoute(codeViewAppBuilder)
